<template>
	<!--
		Route-aware loading fallback (HAP-1889, parent HAP-1884 Phase 2.1).

		Used as the App.vue <Suspense #fallback>. Picks a content-shaped skeleton
		for the main nav pages so a loading route reads as its real layout instead
		of a blank/centered spinner. Routes without a dedicated skeleton fall back
		to the original full-screen spinner, so nothing else regresses.

		Eagerly imported on purpose: a fallback must render the instant a route's
		async chunk/setup is pending — it can't itself be lazy-loaded.
	-->
	<component :is="skeleton" v-if="skeleton" />
	<div v-else class="w-full h-screen flex items-center justify-center">
		<Spinner class="w-16 h-16" :small="true" />
	</div>
</template>

<script>
import Spinner from '../spinner.vue'
import HomeSkeleton from './home-skeleton.vue'
import ResourcesSkeleton from './resources-skeleton.vue'
import ProductsSkeleton from './products-skeleton.vue'
import PodcastsSkeleton from './podcasts-skeleton.vue'
import EventsSkeleton from './events-skeleton.vue'
import NetworkSkeleton from './network-skeleton.vue'
import AccountSkeleton from './account-skeleton.vue'

export default {
	name: 'PageSkeleton',
	components: { Spinner },
	props: {
		// route.path of the page being loaded.
		path: { type: String, default: '' },
	},
	computed: {
		skeleton() {
			const p = (this.path || '').split('?')[0]

			if (p === '/') return HomeSkeleton
			// Resources index + its filter sub-routes (authors/series/topics/date/speakers).
			// A bare /resources/<id> is the single-resource page (different layout), so it
			// is intentionally NOT matched here and falls through to the spinner.
			if (p === '/resources' || /^\/resources\/(authors|series|topics|date|speakers)(\/|$)/.test(p)) return ResourcesSkeleton
			if (p === '/products' || p === '/store') return ProductsSkeleton
			if (p === '/podcasts') return PodcastsSkeleton
			if (p === '/events') return EventsSkeleton
			if (p === '/network/index') return NetworkSkeleton
			if (p === '/account' || p.startsWith('/account/')) return AccountSkeleton

			return null
		},
	},
}
</script>
